import { gql } from 'apollo-angular';

export const AddResourcePermissionDocument = gql`
  mutation addResourcePermission($input: CreateResourcePermissionInputGraphql!) {
    addResourcePermission(input: $input) {
      id
    }
  }
`;
